<div class="padding-xxxbig flex flex-justify-center flex-content-center">
  <mat-spinner diameter="50"></mat-spinner>
</div>
